import { generateFallbackStep } from './generateFallbackStep';
import { getCurrentStep } from './getCurrentStep';

export const resolveStepFromPath = (flowConfig, props) => {
  const currentStepAccordingToPath = getCurrentStep(flowConfig, props);
  if (currentStepAccordingToPath === null && flowConfig.stepNotFoundPath) {
    return generateFallbackStep(flowConfig, props);
  }
  return currentStepAccordingToPath;
};
